module.exports = __webpack_public_path__ + "static/media/Jinx_0.995ee5a9.png";